import type { ReactNode } from 'react';

/**
 * The close glyph shared by `Modal` and `Drawer`, matching the prototypes'
 * cart-drawer close button.
 *
 * `aria-hidden` with `focusable="false"`: the accessible name always lives on
 * the wrapping button (`aria-label={t('common.close')}`), so announcing the
 * SVG too would produce a duplicate. `focusable="false"` is specifically for
 * legacy Internet Explorer/Edge behaviour where SVGs entered the tab order —
 * harmless elsewhere, and cheap insurance.
 */
export function CloseIcon(): ReactNode {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M6 6l12 12M18 6L6 18"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
